import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-c3-three-four-one',
  templateUrl: './c3-three-four-one.component.html',
  styleUrls: ['./c3-three-four-one.component.scss']
})
export class C3ThreeFourOneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
